import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function Filters({ filters, setFilters }) {
    const { getVehicles } = useReportFiltersFetch({  fetchGetVehicles: true});

    const modalitiesOptions = [
        { value: "damage", label: "Avaria" },
        { value: "maintenance", label: "Manutenção" },
        { value: "review", label: "Vistoria" },
    ];

    return (
        <div className={`mb-2 ${minMenuHeight}`}>
            <form className="space-y-4">
                <InputDateTime
                    id="dtStart"
                    label="Data/hora inicial *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtStart ? new Date(filters.dtStart) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date}))}
                />
                <InputDateTime
                    id="dtEnd"
                    label="Data/hora final *"
                    classNameWrapper="w-full"
                    dateFormat="LL"
                    selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                />
                <SelectComponent
                    id="vehicles"
                    label="Veículos"
                    classNameWrapper="w-full"
                    wrapValues={true}
                    isMulti={true}
                    options={getVehicles}
                    value={filters.vehicles}
                    onChange={(value) => setFilters(prev => ({ ...prev, vehicles: value }))}
                />
                <SelectComponent
                    id="modalities"
                    label="Modalidades"
                    classNameWrapper="w-full"
                    isMulti={true}
                    options={modalitiesOptions}
                    value={filters.modalities}
                    onChange={(value) => setFilters(prev => ({ ...prev, modalities: value }))}
                />
            </form>
        </div>
    )
}